export const listaScuole = [
	"SECONDARIA II,ACCADEMIA,AIEM ACCADEMIA ITALIANA DI ESTETICA MAKE-UP",
	"SECONDARIA II,AGENZIA FORMAZIONE PROFESSIONALE,CIOFS-FP PIEMONTE,VIRGINIA AGNELLI",
	"SECONDARIA II,AGENZIA FORMAZIONE PROFESSIONALE,CIOFS-FP PIEMONTE,MARIA MAZZARELLO",
	"SECONDARIA II,AGENZIA FORMAZIONE PROFESSIONALE,CIOFS-FP PIEMONTE,AUXILIUM",
	"SECONDARIA II,AGENZIA FORMAZIONE PROFESSIONALE,CIOFS-FP PIEMONTE,AUXILIUM-LUCENTO",
	"SECONDARIA II,AGENZIA FORMAZIONE PROFESSIONALE,CNOS-FAP PIEMONTE,TORINO AGNELLI",
	"SECONDARIA II,AGENZIA FORMAZIONE PROFESSIONALE,CNOS-FAP PIEMONTE,TORINO VALDOCCO",
	"SECONDARIA II,AGENZIA FORMAZIONE PROFESSIONALE,CNOS-FAP PIEMONTE,TORINO REBAUDENGO",
	"SECONDARIA II GRADO,Agenzia formazione professionale,IMMAGINAZIONE E LAVORO SOC.COOP.,CENTRALE",
	"SECONDARIA II GRADO,Agenzia formazione professionale,IMMAGINAZIONE E LAVORO SOC.COOP.,FONTANESI",
	"SECONDARIA II GRADO,Agenzia formazione professionale,IMMAGINAZIONE E LAVORO SOC.COOP.,DURANDI",
	"SECONDARIA II,Agenzia formazione professionale,SCUOLE TECNICHE SAN CARLO,CAPELLO",
	"SECONDARIA II GRADO,Agenzia formazione professionale,SCUOLA ESTETICA MAKE UP,SEM",
	"NIDO DI INFANZIA,BABY PARKING PRIVATO,ARCA DI NOE",
	"NIDO DI INFANZIA,BABY PARKING PRIVATO,NIDO DI DODO",
	"INFANZIA,BABY PARKING PRIVATO,IL  POLLICINO",
	"NIDO,BABY PARKING PRIVATO,IL  POLLICINO",
	"AGENZIA FORMAZIONE PROFESSIONALE,CENTRO PROVINCIALE PER L'ISTRUZIONE DEGLI ADULTI,CPIA 1 TORINO,VIA DOMODOSSOLA",
	"AGENZIA FORMAZIONE PROFESSIONALE,CENTRO PROVINCIALE PER L'ISTRUZIONE DEGLI ADULTI,CPIA 1 TORINO,VIA LORENZINI",
	"AGENZIA FORMAZIONE PROFESSIONALE,CENTRO PROVINCIALE PER L'ISTRUZIONE DEGLI ADULTI,CPIA 1 TORINO,CASA CIRCONDARIALE",
	"AGENZIA FORMAZIONE PROFESSIONALE,CENTRO PROVINCIALE PER L'ISTRUZIONE DEGLI ADULTI,CPIA 2 TORINO,SEDE CENTRALE N.1",
	"AGENZIA FORMAZIONE PROFESSIONALE,CENTRO PROVINCIALE PER L'ISTRUZIONE DEGLI ADULTI,CPIA 2 TORINO",
	"AGENZIA FORMAZIONE PROFESSIONALE,CENTRO PROVINCIALE PER L'ISTRUZIONE DEGLI ADULTI,CPIA 2 TORINO",
	"AGENZIA FORMAZIONE PROFESSIONALE,CENTRO PROVINCIALE PER L'ISTRUZIONE DEGLI ADULTI,CPIA 3 TORINO,TULLIO DE MAURO",
	"INFANZIA,CIRCOLO DIDATTICO,ALLIEVO, ELSA MORANTE",
	"PRIMARIA,CIRCOLO DIDATTICO,ALLIEVO,ALLIEVO",
	"PRIMARIA,CIRCOLO DIDATTICO,ALLIEVO,FRANCHETTI",
	"INFANZIA,COLLEGIO,SACRA FAMIGLIA,IL PAESE DEL SOLE",
	"PRIMARIA,COLLEGIO,SACRA FAMIGLIA,PRIMARIA",
	"SECONDARIA I GRADO,COLLEGIO,SACRA FAMIGLIA,MEDIA",
	"SECONDARIA II GRADO,COLLEGIO,SACRA FAMIGLIA,LICEI",
	"INFANZIA,COLLEGIO,SAN GIUSEPPE",
	"PRIMARIA,COLLEGIO,SAN GIUSEPPE",
	"SECONDARIA I GRADO,COLLEGIO,SAN GIUSEPPE",
	"SECONDARIA II GRADO,COLLEGIO,SAN GIUSEPPE",
	"PRIMARIA,CONVITTO,UMBERTO I",
	"SECONDARIA I GRADO,CONVITTO,UMBERTO I",
	"SECONDARIA II GRADO,CONVITTO,UMBERTO I,VIA BLIGNY",
	"SECONDARIA II GRADO,CONVITTO,UMBERTO I,VIA BERTOLA",
	"PRIMARIA,COTTOLENGO,COTTOLENGO,VIA S.G.B. COTTOLENGO 14",
	"SECONDARIA I GRADO,COTTOLENGO,COTTOLENGO,VIA S.G.B. COTTOLENGO 14",
	"PRIMARIA,DIREZIONE DIDATTICA,COLLODI,COLLODI",
	"PRIMARIA,DIREZIONE DIDATTICA,COLLODI,RODARI",
	"SECONDARIA II GRADO,ENTE FORMAZIONE PROFESSIONALE,FONDAZIONE CASA DI CARITA' ARTE E MESTIERI ONLUS",
	"PRIMARIA,FONDAZIONE  PRIVATA,FONDAZIONE ANGELO COLASANTO / MARIO FREGONESE,FREGONESE DAVIDE",
	"INFANZIA,FONDAZIONE  PRIVATA,FONDAZIONE ANGELO COLASANTO / MARIO FREGONESE,SAN MSSIMO",
	"INFANZIA,FONDAZIONE  PRIVATA,FONDAZIONE ANGELO COLASANTO / MARIO FREGONESE,STEFANO BONACOSSA",
	"SECONDARIA II GRADO,FORMAZIONE INSERIMENTO LAVORATIVO,FILOS FORMAZIONE",
	"SECONDARIA II,I.I.S.  ( ISTITUTO TECNICO),AMEDEO AVOGADRO,A.AVOGADRO",
	"SECONDARIA II,I.I.S.  LICEO,AMEDEO AVOGADRO,L.S. A.AVOGADRO",
	"INFANZIA,INFANZIA,Nostra Signora del Sacro Cuore NSNCDG",
	"INFANZIA,INFANZIA,LE BIRBE,LE BIRBE",
	"INFANZIA,INFANZIA COMUNALE,UMBERTO I",
	"INFANZIA,INFANZIA MUNICIPALE,BORGO CROCETTA",
	"SECONDARIA II,IPSIA,BIRAGO DALMAZIO,SEDE",
	"SECONDARIA II,IPSIA,BIRAGO DALMAZIO,SUCCURSALE",
	"SECONDARIA I GRADO,ISTITUTI ISTRUZIONE SUPERIORE,BODONI-PARAVIA",
	"SECONDARIA II GRADO,ISTITUTI ISTRUZIONE SUPERIORE,PEANO G.",
	"SECONDARIA II GRADO,ISTITUTI ISTRUZIONE SUPERIORE,ROMOLO ZERBONI",
	"SECONDARIA II GRADO,ISTITUTI ISTRUZIONE SUPERIORE,RUSSELL MORO GUARINI,SEDE :  Bertrand Russell",
	"SECONDARIA II GRADO,ISTITUTI ISTRUZIONE SUPERIORE,RUSSELL MORO GUARINI,SUCC: ALDO MORO",
	"SECONDARIA II GRADO,ISTITUTI ISTRUZIONE SUPERIORE,RUSSELL MORO GUARINI,SUCC: GUARINO GUARINI",
	"Secondaria II grado,ISTITUTI ISTRUZIONE SUPERIORE,SANTORRE DI SANTAROSA",
	"Secondaria II grado,ISTITUTI ISTRUZIONE SUPERIORE,SANTORRE DI SANTAROSA",
	"SECONDARIA II GRADO,ISTITUTO / LICEO,ISTITUTO JUVARRA",
	"SECONDARIA II,ISTITUTO COMMERCIALE,SOMMEILLER  ",
	"INFANZIA,ISTITUTO COMPRENSIVO,ALBERTI-SALGARI",
	"INFANZIA,ISTITUTO COMPRENSIVO,ALBERTI-SALGARI",
	"INFANZIA,ISTITUTO COMPRENSIVO,ALBERTI-SALGARI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,ALBERTI-SALGARI,SANTORRE DI SANTA ROSA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,ALBERTI-SALGARI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,ALBERTI-SALGARI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,ALBERTI-SALGARI,ALBERTI",
	"INFANZIA,ISTITUTO COMPRENSIVO,ALIGHIERI KENNEDY,BELLARDI",
	"INFANZIA,ISTITUTO COMPRENSIVO,ALIGHIERI KENNEDY,MARCO POLO",
	"INFANZIA,ISTITUTO COMPRENSIVO,ALIGHIERI KENNEDY,MARIE CURIE",
	"PRIMARIA,ISTITUTO COMPRENSIVO,ALIGHIERI KENNEDY,KENNEDY",
	"PRIMARIA,ISTITUTO COMPRENSIVO,ALIGHIERI KENNEDY,DEWEY",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,ALIGHIERI KENNEDY,ALIGHIERI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,ALIGHIERI KENNEDY,ALIGHIERI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,ALVARO-GOBETTI,P.GOBETTI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,ALVARO-GOBETTI,R. SCLARANDRI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,ALVARO-GOBETTI,ALVARO",
	"INFANZIA,ISTITUTO COMPRENSIVO,ANTONELLI CASALEGNO,PARRA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,ANTONELLI CASALEGNO,CASALEGNO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,ANTONELLI CASALEGNO,DON MILANI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,ANTONELLI CASALEGNO,ANTONELLI",
	"INFANZIA,ISTITUTO COMPRENSIVO,BARICCO,GIAN BURRASCA",
	"INFANZIA,ISTITUTO COMPRENSIVO,BARICCO,VIA FATTORI",
	"INFANZIA,ISTITUTO COMPRENSIVO,BARICCO,ROUSSEAU",
	"PRIMARIA,ISTITUTO COMPRENSIVO,BARICCO,BARICCO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,BARICCO,FATTORI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,BARICCO,MARITANO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,BOBBIO NOVARO,NOVARO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,BOBBIO NOVARO,LEVI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,BOBBIO NOVARO,BOBBIO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,BOBBIO NOVARO,BOBBIO",
	"INFANZIA,ISTITUTO COMPRENSIVO,CADUTI DI CEFALONIA  MAZZINI,NICHOLAS GREEN",
	"INFANZIA,ISTITUTO COMPRENSIVO,CADUTI DI CEFALONIA  MAZZINI,IL MELO FIORITO",
	"INFANZIA,ISTITUTO COMPRENSIVO,CADUTI DI CEFALONIA  MAZZINI,VIA BALTIMORA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,CADUTI DI CEFALONIA  MAZZINI,MAZZINI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,CADUTI DI CEFALONIA  MAZZINI,CHIOVINI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,CADUTI DI CEFALONIA  MAZZINI,CADUTI DI CEFALONIA",
	"INFANZIA,ISTITUTO COMPRENSIVO,CAIROLI,LA GIOSTRA",
	"INFANZIA,ISTITUTO COMPRENSIVO,CAIROLI,MARY POPPINS",
	"PRIMARIA,ISTITUTO COMPRENSIVO,CAIROLI,CENTRALE",
	"PRIMARIA,ISTITUTO COMPRENSIVO,CAIROLI,SUCCURSALE",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,CAIROLI",
	"INFANZIA,ISTITUTO COMPRENSIVO,GIOVANNI CENA,E16",
	"INFANZIA,ISTITUTO COMPRENSIVO,GIOVANNI CENA,NOVARO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,GIOVANNI CENA,ABBA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,GIOVANNI CENA,CENA TORINO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,GIOVANNI CENA,CESARE ABBA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,GIOVANNI CENA,ABBADIA DI STURA",
	"SECONDARIA II,ISTITUTO COMPRENSIVO,GIOVANNI CENA,PIETRO MICCA",
	"SECONDARIA II,ISTITUTO COMPRENSIVO,GIOVANNI CENA,MARTIRI DEL MARTINETTO",
	"INFANZIA,ISTITUTO COMPRENSIVO,DA VINCI  ANNA FRANK,LUXEMBURG",
	"INFANZIA,ISTITUTO COMPRENSIVO,DA VINCI  ANNA FRANK,DISNEY",
	"INFANZIA,ISTITUTO COMPRENSIVO,DA VINCI  ANNA FRANK,PERRAULT",
	"PRIMARIA,ISTITUTO COMPRENSIVO,DA VINCI  ANNA FRANK,NERUDA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,DA VINCI  ANNA FRANK,AMBROSINI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,DA VINCI  ANNA FRANK,XXV APRILE",
	"PRIMARIA,ISTITUTO COMPRENSIVO,DA VINCI  ANNA FRANK,FRANK",
	"PRIMARIA,ISTITUTO COMPRENSIVO,DA VINCI  ANNA FRANK,GIACHINO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,DA VINCI  ANNA FRANK,DA VINCI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,DA VINCI  ANNA FRANK,SUCC. VIA CAVAGNOLO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,DA VINCI  ANNA FRANK,CHIARA",
	"INFANZIA,ISTITUTO COMPRENSIVO,BRUNO CACCIA  EX DAZEGLIO  NIEVO,SANTA MARGHERITA",
	"INFANZIA,ISTITUTO COMPRENSIVO,BRUNO CACCIA  EX DAZEGLIO  NIEVO,VILLA GENERO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,BRUNO CACCIA  EX DAZEGLIO  NIEVO,ROBERTO DAZEGLIO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,BRUNO CACCIA  EX DAZEGLIO  NIEVO,DON BOSCO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,BRUNO CACCIA  EX DAZEGLIO  NIEVO,SAN GIACOMO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,BRUNO CACCIA  EX DAZEGLIO  NIEVO,IPPOLITO NIEVO",
	"INFANZIA,ISTITUTO COMPRENSIVO,IC DUCA DAOSTA,ARCHIMEDE",
	"PRIMARIA,ISTITUTO COMPRENSIVO,IC DUCA DAOSTA,DUCA DAOSTA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,IC DUCA DAOSTA,CALVINO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,IC DUCA DAOSTA,ARMSTRONG",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,IC DUCA DAOSTA,SCHWEITZER",
	"INFANZIA,ISTITUTO COMPRENSIVO,FAA DI BRUNO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,FAA DI BRUNO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,FAA DI BRUNO",
	"INFANZIA,ISTITUTO COMPRENSIVO,FRASSATI PIER GIORGIO,PRINCIPESSA ISABELLA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,FRASSATI PIER GIORGIO,GOZZANO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,FRASSATI PIER GIORGIO,FRASSATI",
	"INFANZIA,ISTITUTO COMPRENSIVO,GABELLI,ANGELITA DI ANZIO",
	"INFANZIA,ISTITUTO COMPRENSIVO,GABELLI,TOMMASO DI SAVOIA",
	"INFANZIA,ISTITUTO COMPRENSIVO,GABELLI,SARTI STRADA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,GABELLI,GABELLI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,GABELLI,PESTALOZZI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,GABELLI,GABELLI",
	"INFANZIA,ISTITUTO COMPRENSIVO,GOZZI  OLIVETTI,FIORINA",
	"INFANZIA,ISTITUTO COMPRENSIVO,GOZZI  OLIVETTI,BONCOMPAGNI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,GOZZI  OLIVETTI,GOZZI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,GOZZI  OLIVETTI,VILLATA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,GOZZI  OLIVETTI,VITTORIO AMEDEO II",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,GOZZI  OLIVETTI,OLIVETTI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,GOZZI  OLIVETTI,SUCC. OLIVETTI",
	"INFANZIA,ISTITUTO COMPRENSIVO,ILARIA ALPI,PEREMPRUNER",
	"PRIMARIA,ISTITUTO COMPRENSIVO,ILARIA ALPI,PEROTTI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,ILARIA ALPI,DELEDDA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,ILARIA ALPI,DACQUISTO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,ILARIA ALPI,CROCE",
	"INFANZIA,ISTITUTO COMPRENSIVO,KING  MILA,CAROLINA AGAZZI",
	"INFANZIA,ISTITUTO COMPRENSIVO,KING  MILA,KING",
	"PRIMARIA,ISTITUTO COMPRENSIVO,KING  MILA,KING 1",
	"PRIMARIA,ISTITUTO COMPRENSIVO,KING  MILA,KING 3",
	"PRIMARIA,ISTITUTO COMPRENSIVO,KING  MILA,ROSA AGAZZI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,KING  MILA,MASSIMO MILA",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,KING  MILA,SUCC MASSIMO MILA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,LEONE SINIGAGLIA,SINIGAGLIA",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,LEONE SINIGAGLIA,ADA NEGRI",
	"INFANZIA,ISTITUTO COMPRENSIVO,LEONE SINIGAGLIA,BRUNO MUNARI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,LEONE SINIGAGLIA,EUGENIO MONTALE",
	"INFANZIA,ISTITUTO COMPRENSIVO,MANZONI,DAZEGLIO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,MANZONI,RAYNERI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,MANZONI,MANZONI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,MARCONI ANTONELLI,ALESSANDRO ANTONELLI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,MARCONI ANTONELLI,GUGLIELMO MARCONI",
	"INFANZIA,ISTITUTO COMPRENSIVO,MATTEOTTI RIGNON,MATERNA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,MATTEOTTI RIGNON,CARDUCCI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,MATTEOTTI RIGNON,RIGNON",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,MATTEOTTI RIGNON,LORENZO IL MAGNIFICO",
	"INFANZIA,ISTITUTO COMPRENSIVO,MATTEOTTI PELLICO,BORGARELLO",
	"INFANZIA,ISTITUTO COMPRENSIVO,MATTEOTTI PELLICO,FIOCCARDO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,MATTEOTTI PELLICO,BALBIS GARRONE",
	"PRIMARIA,ISTITUTO COMPRENSIVO,MATTEOTTI PELLICO,PARATO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,MATTEOTTI PELLICO,PELLICO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,MATTEOTTI PELLICO,MATTEOTTI",
	"INFANZIA,ISTITUTO COMPRENSIVO,NIGRA,BOVETTI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,NIGRA,GAMBARO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,NIGRA,SUCCURSALE EX DE SANCTIS",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,NIGRA,SEDE",
	"INFANZIA,ISTITUTO COMPRENSIVO,PACCHIOTTI VIA REVEL,INFANZIA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PACCHIOTTI VIA REVEL,RICARDI DI NETRO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PACCHIOTTI VIA REVEL,SCLOPIS",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,PACCHIOTTI VIA REVEL,MEUCCI",
	"INFANZIA,ISTITUTO COMPRENSIVO,PACINOTTI,MANZONI",
	"INFANZIA,ISTITUTO COMPRENSIVO,PACINOTTI,FRECCIA AZZURRA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PACINOTTI,BONCOMPAGNI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PACINOTTI,DE FILIPPO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PACINOTTI,MANZONI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,PACINOTTI,PACINOTTI",
	"INFANZIA,ISTITUTO COMPRENSIVO,PADRE GEMELLI,E15",
	"INFANZIA,ISTITUTO COMPRENSIVO,PADRE GEMELLI,ANNA BECHIS",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PADRE GEMELLI,PADRE GEMELLI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PADRE GEMELLI,MARGHERITA DI SAVOIA",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,PADRE GEMELLI,POLA",
	"INFANZIA,ISTITUTO COMPRENSIVO,PALAZZESCHI ALDO,ANDERSEN",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PALAZZESCHI ALDO,DAL PIAZ",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PALAZZESCHI ALDO,OTTINO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,PALAZZESCHI ALDO,PALAZZESCHI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PARRI  VIAN,CAPPONI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PARRI  VIAN,PARRI",
	"INFANZIA,ISTITUTO COMPRENSIVO,PARRI  VIAN,INFANZIA",
	"INFANZIA,ISTITUTO COMPRENSIVO,PARRI  VIAN,KLEIN",
	"INFANZIA,ISTITUTO COMPRENSIVO,PARRI  VIAN,INFANZIA",
	"INFANZIA,ISTITUTO COMPRENSIVO,PARRI  VIAN,INFANZIA",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,PARRI  VIAN,NOSEGNO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,PARRI  VIAN,VIAN",
	"INFANZIA,ISTITUTO COMPRENSIVO,PEROTTI TOSCANINI, ROUSSEAU",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PEROTTI TOSCANINI, TOSCANINI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,PEROTTI TOSCANINI, PEROTTI",
	"INFANZIA,ISTITUTO COMPRENSIVO,PERTINI,LA PIMPA",
	"INFANZIA,ISTITUTO COMPRENSIVO,PERTINI,LINUS",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PERTINI,DUCA DEGLI ABRUZZI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,PERTINI,VICO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PEYRON,RE UMBERTO I",
	"PRIMARIA,ISTITUTO COMPRENSIVO,PEYRON,RE UMBERTO I",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,PEYRON,PEYRON",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,PEYRON,SCUOLA OSPEDALIERA REGINA MARGHERITA",
	"INFANZIA,ISTITUTO COMPRENSIVO,REGIO PARCO,MARIA TERESA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,REGIO PARCO,LESSONA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,REGIO PARCO,DE AMICIS",
	"PRIMARIA,ISTITUTO COMPRENSIVO,REGIO PARCO,POLI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,REGIO PARCO,GIACOSA",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,REGIO PARCO,VERGA",
	"INFANZIA,ISTITUTO COMPRENSIVO,RICASOLI,RODARI",
	"INFANZIA,ISTITUTO COMPRENSIVO,RICASOLI,VANCHIGLIETTA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,RICASOLI, FONTANA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,RICASOLI,MURATORI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,RICASOLI,ROSSELLI",
	"INFANZIA,ISTITUTO COMPRENSIVO,RITA LEVI MONTALCINI,VIA COLLEGNO",
	"INFANZIA,ISTITUTO COMPRENSIVO,RITA LEVI MONTALCINI,CASA DEI BAMBINI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,RITA LEVI MONTALCINI,VIA COLLEGNO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,RITA LEVI MONTALCINI,ALFIERI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,RITA LEVI MONTALCINI,PASCOLI (EX PALMIERI)",
	"PRIMARIA,ISTITUTO COMPRENSIVO,SABA,RADICE",
	"PRIMARIA,ISTITUTO COMPRENSIVO,SABA,GALIMBERTI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,SABA,SABA",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,SABA,SUCC. PERTINI",
	"INFANZIA,ISTITUTO COMPRENSIVO,SALVEMINI,CASTELLO MIRAFIORI",
	"INFANZIA,ISTITUTO COMPRENSIVO,SALVEMINI,M. VENTRE",
	"PRIMARIA,ISTITUTO COMPRENSIVO,SALVEMINI,CASTELLO MIRAFIORI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,SALVEMINI,ELSA MORANTE",
	"PRIMARIA,ISTITUTO COMPRENSIVO,SALVEMINI,SALVEMINI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,SALVEMINI,CASTELLO MIRAFIORI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,SALVEMINI,COLOMBO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,SIBILLA ALERAMO,ALERAMO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,SIBILLA ALERAMO,AMELIA ANGELINI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,SIBILLA ALERAMO,BEATA VERGINE DI CAMPAGNA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,SIBILLA ALERAMO,SIBILLA ALERAMO",
	"INFANZIA,ISTITUTO COMPRENSIVO,SIDOLI,FANCIULLI",
	"INFANZIA,ISTITUTO COMPRENSIVO,SIDOLI,KANDINSKIJ",
	"INFANZIA,ISTITUTO COMPRENSIVO,SIDOLI,KELLER",
	"PRIMARIA,ISTITUTO COMPRENSIVO,SIDOLI,DOGLIOTTI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,SIDOLI,SUCC. VIA FLECCHIA",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,SIDOLI,DOGLIOTTI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,SIDOLI,SUCC. VIA PALMA DI CESNOLA",
	"INFANZIA,ISTITUTO COMPRENSIVO,SPAZIANI M.LUISA (I.C. RACCONIGI),FELICE QUARANTA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,SPAZIANI M.LUISA (I.C. RACCONIGI),BATTISTI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,SPAZIANI M.LUISA (I.C. RACCONIGI),GABRIO CASATI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,SPAZIANI M.LUISA (I.C. RACCONIGI),DROVETTI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,SPINELLI,PRIMARIA",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,SPINELLI,MEDIA",
	"SECONDARIA II GRADO,ISTITUTO COMPRENSIVO,SPINELLI,LICEO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,TOMMASEO",
	"INFANZIA,ISTITUTO COMPRENSIVO,TOMMASEO,PLANA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,TOMMASEO,TOMMASEO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,TOMMASEO,SAN FRANCESCO DASSISI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,TOMMASEO,CALVINO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,TOMMASEO,VERDI",
	"INFANZIA,ISTITUTO COMPRENSIVO,TORINO II,VIA BEINASCO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,TORINO II,G. PARINI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,TORINO II,AURORA",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,TORINO II,E. MORELLI",
	"INFANZIA,ISTITUTO COMPRENSIVO,TUROLDO,VALLETTE A",
	"INFANZIA,ISTITUTO COMPRENSIVO,TUROLDO,VIA MAGNOLIE 15",
	"PRIMARIA,ISTITUTO COMPRENSIVO,TUROLDO,COSTA",
	"PRIMARIA,ISTITUTO COMPRENSIVO,TUROLDO,GIANELLI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,TUROLDO,LEOPARDI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,TUROLDO,TUROLDO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,FOSCOLO,COPPINO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,FOSCOLO,GIULIA FALLETTI DI BAROLO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,FOSCOLO,FOSCOLO",
	"INFANZIA,ISTITUTO COMPRENSIVO,VERCELLI,PERRAULT",
	"INFANZIA,ISTITUTO COMPRENSIVO,VERCELLI,LUZZATI",
	"INFANZIA,ISTITUTO COMPRENSIVO,VERCELLI,LUZZATI",
	"PRIMARIA,ISTITUTO COMPRENSIVO,VERCELLI,SABIN",
	"PRIMARIA,ISTITUTO COMPRENSIVO,VERCELLI,MARCHESA",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,VERCELLI,VIOTTI",
	"INFANZIA,ISTITUTO COMPRENSIVO,VIA COLLINO,DARBOREA",
	"INFANZIA,ISTITUTO COMPRENSIVO,VIA COLLINO,LEVI MONTALCINI",
	"INFANZIA,ISTITUTO COMPRENSIVO,VIA COLLINO,CENTRO EUROPA B",
	"PRIMARIA,ISTITUTO COMPRENSIVO,VIA COLLINO,MAZZARELLO",
	"PRIMARIA,ISTITUTO COMPRENSIVO,VIA COLLINO,VIDARI",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,VIA COLLINO,MODIGLIANI",
	"INFANZIA,ISTITUTO COMPRENSIVO,VITTORINO DA FELTRE",
	"INFANZIA,ISTITUTO COMPRENSIVO,VITTORINO DA FELTRE",
	"PRIMARIA,ISTITUTO COMPRENSIVO,VITTORINO DA FELTRE",
	"SECONDARIA II,ISTITUTO COMPRENSIVO,VITTORINO DA FELTRE",
	"PRIMARIA,ISTITUTO COMPRENSIVO,VIVALDI-MURIALDO,DON MURIALDO",
	"SECONDARIA I GRADO,ISTITUTO COMPRENSIVO,VIVALDI-MURIALDO   ,ANTONIO VIVALDI",
	",ISTITUTO COMPRENSIVO,ALIGHIERI KENNEDY,ALIGHIERI",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,COPERNICO LUXEMBURG",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,COPERNICO LUXEMBURG",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,EINSTEIN ALBERT,LICEO SCIENZE APPLICATE",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,EINSTEIN ALBERT,LICEO UMANISTICHE / LINGUISTICO",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,EINSTEIN ALBERT,LICEO SCIENZE UMANE",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,GALILEI FERRARI,GALILEO GALILEI (SERALE)",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE, GALILEI FERRARI,ENZO FERRARI (L. SCIENTIFICO)",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,GIOLITTI",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,GIORDANO BRUNO",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,GIULIO I.C.",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,GIULIO I.C.,SEZIONE CARCERARIA",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,GOBETTI MARCHESINI CASALE ARDUINO",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,GOBETTI MARCHESINI CASALE ARDUINO,CASALE",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,GOBETTI MARCHESINI CASALE ARDUINO,OSPEDALIERA OIRM",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,GOBETTI MARCHESINI CASALE ARDUINO,OSPEDALIERA CTO-USU",
	"SECONDARIA II,ISTITUTO ISTRUZIONE  SUPERIORE,MAJORANA E.,ISTITUTO TECNICO",
	"SECONDARIA II,ISTITUTO ISTRUZIONE  SUPERIORE,MAJORANA E.,LICEO",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,PLANA",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,SELLA AALTO LAGRANGE,SELLA",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,SELLA AALTO LAGRANGE,AALTO",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE  SUPERIORE,SELLA AALTO LAGRANGE,LAGRANGE",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE SUPERIORE,BOSELLI,TO1  TO4",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE SUPERIORE,BOSELLI,TO2",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE SUPERIORE,BOSELLI,TO3",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE SUPERIORE,CALAMANDREI,SEDE",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE SUPERIORE,CALAMANDREI,SUCCURSALE",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE SUPERIORE,STEINER ALBE,SEDE",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE SUPERIORE,STEINER ALBE,SUCC. VIA MONGINEVRO",
	"SECONDARIA II GRADO,ISTITUTO ISTRUZIONE SUPERIORE,STEINER ALBE,SUCC. VIA PESARO",
	"INFANZIA,ISTITUTO PARITARIO,CADORNA-IST.ADORAZIONE PERPETUA DEL SACRO CUORE",
	"PRIMARIA,ISTITUTO PARITARIO,ADORAZIOE CADORNA",
	"SECONDARIA II,ISTITUTO PARITARIO,ADORAZIONE",
	"SECONDARIA II GRADO,ISTITUTO PARITARIO,ISTITUTO FELLINI (ISTITUTO PER IL CINEMA E PER IL TEATRO)",
	"SECONDARIA I GRADO,ISTITUTO PARITARIO,ISTITUTO SOCIALE",
	"INFANZIA,ISTITUTO PARITARIO,ISTITUTO SOCIALE,GIARDINO DEL COLIBRI",
	"PRIMARIA,ISTITUTO PARITARIO,ISTITUTO SOCIALE",
	"SECONDARIA II,ISTITUTO PARITARIO,ISTITUTO SOCIALE,LICEO",
	"INFANZIA,ISTITUTO PARITARIO,MADRE MAZZARELLO",
	"PRIMARIA,ISTITUTO PARITARIO,MADRE MAZZARELLO",
	"SECONDARIA I GRADO,ISTITUTO PARITARIO,MADRE MAZZARELLO",
	"SECONDARIA II,ISTITUTO PARITARIO,MADRE MAZZARELLO",
	"INFANZIA,ISTITUTO PARITARIO,MARIA AUSILIATRICE",
	"PRIMARIA,ISTITUTO PARITARIO,MARIA AUSILIATRICE",
	"SECONDARIA I GRADO,ISTITUTO PARITARIO,MARIA AUSILIATRICE",
	"SECONDARIA II,ISTITUTO PARITARIO,MARIA AUSILIATRICE",
	"PRIMARIA,ISTITUTO PARITARIO,PRINCIPESSA CLOTILDE DI SAVOIA",
	"INFANZIA,ISTITUTO PARITARIO,SANTANNA",
	"PRIMARIA,ISTITUTO PARITARIO,SANTANNA",
	"SECONDARIA I GRADO,ISTITUTO PARITARIO,SANTANNA",
	"SECONDARIA II GRADO,ISTITUTO PARITARIO,SANTANNA",
	"INFANZIA,ISTITUTO PARITARIO,SANTANNA",
	"PRIMARIA,ISTITUTO PARITARIO,SANTANNA",
	"INFANZIA,ISTITUTO PARITARIO,VIRGINIA AGNELLI",
	"PRIMARIA,ISTITUTO PARITARIO,VIRGINIA AGNELLI",
	"SECONDARIA II,ISTITUTO PER SORDI,MARGAROTTO",
	"SECONDARIA II GRADO,ISTITUTO PRIVATO,EDOARDO AGNELLI ISTITUTO INTERNAZIONALE, ISTITUTO TECNICO",
	"SECONDARIA I GRADO,ISTITUTO PRIVATO,EDOARDO AGNELLI ISTITUTO INTERNAZIONALE,LICEO",
	"SECONDARIA I GRADO,ISTITUTO PRIVATO,EDOARDO AGNELLI ISTITUTO INTERNAZIONALE,(SCUOLE MEDIE)",
	"SECONDARIA II GRADO,ISTITUTO PROFESSIONALE STATALE,G. COLOMBATTO,SEDE",
	"SECONDARIA II GRADO,ISTITUTO PROFESSIONALE STATALE,G. COLOMBATTO,SUCCURSALE",
	"SECONDARIA II GRADO,ISTITUTO SUPERIORE PROFESSIONALE, J. B. BECCARI,SUCCURSALE",
	"SECONDARIA II GRADO,ISTITUTO SUPERIORE PROFESSIONALE, J. B. BECCARI,SUCCURSALE",
	"SECONDARIA II GRADO,ISTITUTO SUPERIORE PROFESSIONALE, J. B. BECCARI,SEDE",
	"SECONDARIA II GRADO,ISTITUTO SUPERIORE PROFESSIONALE,BOSSO-MONTI,SEDE",
	"SECONDARIA II GRADO,ISTITUTO SUPERIORE PROFESSIONALE,BOSSO-MONTI,SUCCURSALE",
	"SECONDARIA II GRADO,ISTITUTO SUPERIORE PROFESSIONALE,BOSSO-MONTI,SUCCURSALE",
	"SECONDARIA II,ISTITUTO TECNICO  ISTRUZIONE  SUPERIORE,CARLO LEVI",
	"SECONDARIA II GRADO,ISTITUTO TECNICO ISTRUZIONE SUPERIORE,CARLO GRASSI",
	"SECONDARIA II GRADO,LICEO,GALILEO FERRARIS",
	"SECONDARIA I GRADO,LICEO ARTISTICO,PASSONI",
	"SECONDARIA II,LICEO ARTISTICO,PRIMO",
	"SECONDARIA I GRADO,LICEO ARTISTICO,PASSONI",
	"SECONDARIA II GRADO,LICEO LINGUISTICO,REGINA MARGHERITA,SEDE",
	"SECONDARIA II GRADO,LICEO LINGUISTICO,REGINA MARGHERITA,SUCC. CASANA",
	"SECONDARIA II GRADO,LICEO LINGUISTICO,REGINA MARGHERITA,SUCC. CADUTI SUL LAVORO",
	"SECONDARIA II GRADO,LICEO PARITARIO,FLORA",
	"SECONDARIA II GRADO,LICEO PARITARIO COREUTICO / TEATRALE,LICEO GERMANA ERBA,LICEO GERMANA ERBA TEATRO NUOVO",
	"SECONDARIA II,LICEO SCIENTIFICO / TECNICO,PRIMO LEVI",
	"SECONDARIA II,LICEO SCIENTIFICO STATALE,VOLTA",
	"SECONDARIA II,LICEO STATALE,DOMENICO BERTI",
	"SECONDARIA II GRADO,LICEO STATALE,CATTANEO,SEDE CENTRALE",
	"SECONDARIA II GRADO,LICEO STATALE,CATTANEO,SUCCURSALE",
	"SECONDARIA II GRADO,LICEO STATALE,LICEO CLASSICO E MUSICALE C. CAVOUR,SEDE CENTRALE",
	"SECONDARIA II GRADO,LICEO STATALE,LICEO CLASSICO E MUSICALE C. CAVOUR,SUCCURSALE",
	"SECONDARIA II GRADO,LICEO STATALE,LICEO ARTISTICO COTTINI,SEDE",
	"SECONDARIA II GRADO,LICEO STATALE,LICEO ARTISTICO COTTINI,COTTINI 2 SUCCURSALE",
	"SECONDARIA II GRADO,LICEO STATALE,LICEO GIOBERTI,SEDE",
	"SECONDARIA II GRADO,LICEO STATALE,LICEO GIOBERTI,SUCC. GIULIA DI BAROLO",
	"SECONDARIA II GRADO,LICEO STATALE,GOBETTI PIERO,SEDE",
	"SECONDARIA II GRADO,LICEO STATALE,GOBETTI PIERO,SUCC GB",
	"SECONDARIA II GRADO,LICEO STATALE,GOBETTI PIERO,SUCC CP",
	"SECONDARIA II,LICEO STATALE,MASSIMO DAZEGLIO",
	"SECONDARIA II GRADO,LICEO STATALE,VITTORIO ALFIERI",
	"SECONDARIA II,LICEO STATALE,DOMENICO BERTI",
	"LUDOTECA,LUDOTECA COMUNALE,LUDOTECA COMUNALE IL DRAGO VOLANTE",
	"SECONDARIA II,MBA : ACCADEMIA DI TRUCCO,MAKING BEAUTY ACADEMY",
	"NIDO,NIDO AZIENDALE,NIDO DEI BIMBI INTESA SAN PAOLO",
	"NIDO DI INFANZIA,NIDO COMUNALE,BIANCALUNA / CARUTTI",
	"NIDO DI INFANZIA,NIDO COMUNALE,COOP FRASSATI,BIMBI ENTRATE",
	"NIDO DI INFANZIA,NIDO COMUNALE,BUGNANO SARDI",
	"NIDO DI INFANZIA,NIDO COMUNALE,CAMILLA REVERA",
	"NIDO DI INFANZIA,NIDO COMUNALE,CAVOUR  -  LALBERO DI SOFIA",
	"NIDO DI INFANZIA,NIDO COMUNALE,COLORANDIA",
	"NIDO DI INFANZIA,NIDO COMUNALE,IL KOALA",
	"NIDO DI INFANZIA,NIDO COMUNALE,LA MARMOTTA",
	"NIDO DI INFANZIA,NIDO COMUNALE,NIDO DEL DIALOGO /SERMING)",
	"NIDO DI INFANZIA,NIDO COMUNALE,DUMBO",
	"NIDO DI INFANZIA,NIDO COMUNALE,ELVIRA VERDE",
	"NIDO DI INFANZIA,NIDO COMUNALE,F. DOLTO",
	"NIDO DI INFANZIA,NIDO COMUNALE,GIULIO",
	"NIDO DI INFANZIA,NIDO COMUNALE,IL GRILLO",
	"NIDO DI INFANZIA,NIDO COMUNALE,GUIZZINO",
	"NIDO DI INFANZIA,NIDO COMUNALE,I PUFFI",
	"NIDO DI INFANZIA,NIDO COMUNALE,TRICHECO",
	"NIDO DI INFANZIA,NIDO COMUNALE,IL CANGURO",
	"NIDO DI INFANZIA,NIDO COMUNALE,IL CERCHIO",
	"NIDO DI INFANZIA,NIDO COMUNALE,IL FARO",
	"NIDO DI INFANZIA,NIDO COMUNALE,IL GIARDINO DELLE FIABE",
	"NIDO DI INFANZIA,NIDO COMUNALE,IL GIRASOLE",
	"NIDO DI INFANZIA,NIDO COMUNALE,IL MAGO DI OZ",
	"NIDO DI INFANZIA,NIDO COMUNALE,IL MELOGRANO",
	"NIDO DI INFANZIA,NIDO COMUNALE,IL PULCINO",
	"NIDO DI INFANZIA,NIDO COMUNALE,LA NIDIATA",
	"NIDO DI INFANZIA,NIDO COMUNALE,LA PINETA",
	"NIDO DI INFANZIA,NIDO COMUNALE,LANATROCCOLO",
	"NIDO DI INFANZIA,NIDO COMUNALE,LE PRATOLINE",
	"NIDO DI INFANZIA,NIDO COMUNALE,MAFALDA",
	"NIDO DI INFANZIA,NIDO COMUNALE,MELIS",
	"NIDO DI INFANZIA,NIDO COMUNALE,ORVIETO",
	"NIDO DI INFANZIA,NIDO COMUNALE,PETER PAN",
	"NIDO DI INFANZIA,NIDO COMUNALE,PICCOLO PRINCIPE",
	"NIDO DI INFANZIA,NIDO COMUNALE,COOP ORSA / ROVEDA",
	"NIDO DI INFANZIA,NIDO COMUNALE,ROVERETO,(ORSA COOP)",
	"NIDO DI INFANZIA,NIDO COMUNALE,SNOOPY",
	"NIDO DI INFANZIA,NIDO COMUNALE,COLORANDIA",
	"NIDO DI INFANZIA,NIDO COMUNALE,IL VELIERO",
	"NIDO DI INFANZIA,NIDO COMUNALE,LAQUILONE,LAQUILONE",
	"NIDO,NIDO COMUNALE,NIDO DINFANZIA MAMIANI,NIDO MAMIANI",
	"NIDO DI INFANZIA,NIDO COMUNALE,NIDO DENIS",
	"NIDO DI INFANZIA,NIDO COMUNALE,NIDO DENIS",
	"INFANZIA,NIDO COMUNALE,E. LUZZATI / BRUINO 14,E. LUZZATI / BRUINO 14",
	"NIDO DI INFANZIA,NIDO MUNICIPALE,COCCINELLE",
	"NIDO DI INFANZIA,NIDO MUNICIPALE,ALICE",
	"NIDO DI INFANZIA,NIDO MUNICIPALE,ARCOBALENO",
	"NIDO DI INFANZIA,NIDO MUNICIPALE,BANFO (EX INCET)",
	"NIDO DI INFANZIA,NIDO MUNICIPALE,ORSA COOP. / FENOGLIO",
	"NIDO DI INFANZIA,NIDO MUNICIPALE,ALDIA COOP / FOSSANO",
	"NIDO DI INFANZIA,NIDO MUNICIPALE,COOP ORSA / IL LAGHETTO",
	"NIDO DI INFANZIA,NIDO MUNICIPALE,LE API",
	"NIDO DI INFANZIA,NIDO MUNICIPALE, Astrid Lindgren",
	"NIDO DI INFANZIA,NIDO PARITARIO,CASA DEI BIMBI",
	"NIDO DI INFANZIA,NIDO PARITARIO,SANTISSIMA ANNUNZIATA",
	"NIDO DI INFANZIA,NIDO PRIVATO,AL BOSCHETTO  SAS DI OLOCCO C. & C",
	"NIDO DI INFANZIA,NIDO PRIVATO,IL COCCIOLATO",
	"NIDO DI INFANZIA,NIDO PRIVATO,IL VILLAGGIO DI SMILE",
	"NIDO DI INFANZIA,NIDO PRIVATO,LANGIOLETTO",
	"NIDO DI INFANZIA,NIDO PRIVATO,LANGIOLETTO",
	"NIDO DI INFANZIA,NIDO PRIVATO,MELARIDO",
	"NIDO DI INFANZIA,NIDO PRIVATO,POPPY",
	"NIDO DI INFANZIA,NIDO PRIVATO,PRIMI PASSI",
	"NIDO DI INFANZIA,NIDO PRIVATO,IL NIDO DELLE COCCINELLE",
	"NIDO DI INFANZIA,NIDO PRIVATO,TOPOLINUS SNC",
	"NIDO DI INFANZIA,NIDO PRIVATO,LA CASA SULLALBERO",
	"NIDO DI INFANZIA,NIDO PRIVATO,BUBUSETTETE,BUBUSETTETE",
	"NIDO,NIDO PRIVATO,NIDO IL GIARDINO DI AURORA,NIDO IL GIARDINO DI AURORA",
	"NIDO,NIDO PRIVATO,LE BIRBE,LE BIRBE",
	"NIDO,NIDO PRIVATO,A PICCOLI PASSI,A PICCOLI PASSI",
	"NIDO,NIDO PRIVATO,LA CICOGNA,LA CICOGNA",
	"NIDO,NIDO PRIVATO,IL CIUCCIO DI NINA,IL CIUCCIO DI NINA",
	"INFANZIA,NIDO PRIVATO,ASILO DI MICKEY",
	"INFANZIA,PARITARIA  APPARTENENTE FISM,SCUOLA DELLINFANZIA PARITARIA SAN PIO X,SAN PIO X",
	"INFANZIA,SCOLA PARITARIA,STIGMATE S. FRANCESCO,STIGMATE S. FRANCESCO",
	"PRIMARIA,SCOLA PARITARIA,PROTETTE SAN GIUSEPPE",
	"SECONDARIA I GRADO,SCOLA PARITARIA,PROTETTE SAN GIUSEPPE",
	"INFANZIA,SCOLA PARITARIA,THAON DI REVEL,THAON DI REVEL",
	"INFANZIA,SCUOLA COMUNALE,BRUNELLA",
	"INFANZIA,SCUOLA COMUNALE,BEATRIX POTTER",
	"INFANZIA,SCUOLA COMUNALE,SANSOVINO",
	"INFANZIA,SCUOLA COMUNALE,VIBERTI",
	"INFANZIA,SCUOLA COMUNALE,IQBAL MASIH",
	"INFANZIA,SCUOLA COMUNALE,BARCA",
	"INFANZIA,SCUOLA COMUNALE,BAY",
	"INFANZIA,SCUOLA COMUNALE,BRUNER",
	"INFANZIA,SCUOLA COMUNALE,BRUNO CIARI",
	"INFANZIA,SCUOLA COMUNALE,CORA CORALINA",
	"INFANZIA,SCUOLA COMUNALE,FRIDA KALO",
	"INFANZIA,SCUOLA COMUNALE,G.DELEDDA",
	"INFANZIA,SCUOLA COMUNALE,IL CILIEGIO",
	"INFANZIA,SCUOLA COMUNALE,JOAN MIRO",
	"INFANZIA,SCUOLA COMUNALE,LE PRIMULE",
	"INFANZIA,SCUOLA COMUNALE,LUGARO",
	"INFANZIA,SCUOLA COMUNALE,MALTA",
	"INFANZIA,SCUOLA COMUNALE,MARGHERITA HACK",
	"INFANZIA,SCUOLA COMUNALE,MILLE COLORI",
	"INFANZIA,SCUOLA COMUNALE,MIRAFIORI SUD",
	"INFANZIA,SCUOLA COMUNALE,PICCOLO TORINO",
	"INFANZIA,SCUOLA COMUNALE,ROSA PARKS",
	"INFANZIA,SCUOLA COMUNALE,SILVANA ALLASIA_",
	"INFANZIA,SCUOLA COMUNALE,SOLE",
	"INFANZIA,SCUOLA COMUNALE,SUOR DE MURO GIUSEPPINA",
	"INFANZIA,SCUOLA COMUNALE,VITTORIO VENETO",
	"INFANZIA,SCUOLA COMUNALE,FANCIULLI",
	"INFANZIA,SCUOLA COMUNALE,LA NIDIATA",
	"INFANZIA,SCUOLA COMUNALE,M.L. RUBATTO",
	"INFANZIA,SCUOLA COMUNALE,LA CASA DEL SOLE,LA CASA DEL SOLE",
	"NIDO DI INFANZIA,SCUOLA COMUNALE,LA TESORIERA,LA TESORIERA",
	"INFANZIA,SCUOLA COMUNALE,CELLINI,CELLINI",
	"NIDO DI INFANZIA,SCUOLA COMUNALE,FIORI DEL MELOGRANO,FIORI DEL MELOGRANO / charlie chaplin",
	"INFANZIA,SCUOLA DELLINFANZIA MUNICIPALE,SASSI",
	"Infanzia,SCUOLA DELL'INFANZIA PARROCCHIALE,PARROCCHIA MARIA SPERANZA NOSTRA,PARROCCHIA MARIA SPERANZA NOSTRA",
	"INFANZIA,SCUOLA INTERNAZIONALE,VITTORIA INTERNATIONAL SCHOOL,VITTORIA JUNIOR INTERNATIONAL SCHOOL",
	"SECONDARIA I GRADO,SCUOLA INTERNAZIONALE,VITTORIA INTERNATIONAL SCHOOL,VITTORIA JUNIOR INTERNATIONAL SCHOOL",
	"PRIMARIA,SCUOLA INTERNAZIONALE,VITTORIA INTERNATIONAL SCHOOL,VITTORIA JUNIOR INTERNATIONAL SCHOOL",
	"SECONDARIA II,SCUOLA INTERNAZIONALE,VITTORIA INTERNATIONAL SCHOOL,LICEO LINGUISTICO EUROPEO VITTORIA",
	"INFANZIA,SCUOLA MUNICIPALE,EUROPEA",
	"INFANZIA,SCUOLA MUNICIPALE,MARC CHAGALL",
	"INFANZIA,SCUOLA MUNICIPALE,MODIGLIANI",
	"INFANZIA,SCUOLA MUNICIPALE,ALBERTO MANZI",
	"INFANZIA,SCUOLA MUNICIPALE,ANNA MARIA CAVAGLIA",
	"INFANZIA,SCUOLA MUNICIPALE,ARCOBALENO",
	"INFANZIA,SCUOLA MUNICIPALE,DE PANIS",
	"INFANZIA,SCUOLA MUNICIPALE,FREINET",
	"INFANZIA,SCUOLA MUNICIPALE,MILLEFONTI",
	"INFANZIA,SCUOLA MUNICIPALE,PRINCIPESSA DI PIEMONTE",
	"INFANZIA,SCUOLA MUNICIPALE, Elvira Pajetta",
	"INFANZIA,SCUOLA PARITARIA,AL BOSCHETTO  SAS DI OLOCCO C. & C",
	"INFANZIA,SCUOLA PARITARIA,BORGNANA PICCO",
	"PRIMARIA,SCUOLA PARITARIA,SAN GIUSEPPE CAFASSO",
	"INFANZIA,SCUOLA PARITARIA,SAN GIUSEPPE CAFASSO",
	"SECONDARIA I GRADO,SCUOLA PARITARIA,SAN GIUSEPPE CAFASSO",
	"INFANZIA,SCUOLA PARITARIA,CASA DEI BIMBI",
	"INFANZIA,SCUOLA PARITARIA,IL MICINO SRL",
	"INFANZIA,SCUOLA PARITARIA,ASSUNZIONE DI MARIA VERGINE,LINGOTTO",
	"INFANZIA,SCUOLA PARITARIA,CLOTILDE",
	"INFANZIA,SCUOLA PARITARIA,LUIGI GRASSI",
	"INFANZIA,SCUOLA PARITARIA,MIRAFIORI NORD",
	"INFANZIA,SCUOLA PARITARIA,SANTA RITA",
	"INFANZIA,SCUOLA PARITARIA,CANONICO FERRERO",
	"INFANZIA,SCUOLA PARITARIA,NOSTRA SIGNORA DELLA SALUTE",
	"INFANZIA,SCUOLA PARITARIA,SACRO CUORE",
	"INFANZIA,SCUOLA PARITARIA,SAN GIULIO DORTA",
	"INFANZIA,SCUOLA PARITARIA,SAN GIUSEPPE LAVORATORE",
	"INFANZIA,SCUOLA PARITARIA,TESORIERA",
	"INFANZIA,SCUOLA PARITARIA,REGINA PACIS",
	"INFANZIA,SCUOLA PARITARIA,SANTA MARIA GORETTI",
	"INFANZIA,SCUOLA PARITARIA,S. MARIA",
	"INFANZIA,SCUOLA PARITARIA,TEDESCHI -  ASSANDRI",
	"SECONDARIA I GRADO,SCUOLA PARITARIA,LICEO JUVENTUS",
	"INFANZIA,SCUOLA PARITARIA,MARIA CONSOLATRICE (ISMC)",
	"PRIMARIA,SCUOLA PARITARIA,MARIA CONSOLATRICE (ISMC),GESU BAMBINO",
	"INFANZIA,SCUOLA PARITARIA,PROTETTE SAN GIUSEPPE",
	"PRIMARIA,SCUOLA PARITARIA,SAN DOMENICO SAVIO",
	"INFANZIA,SCUOLA PARITARIA,SCUOLA EBRAICA DI TORINO,COLONNA E FINZI",
	"PRIMARIA,SCUOLA PARITARIA,SCUOLA EBRAICA DI TORINO,COLONNA E FINZI",
	"SECONDARIA I GRADO,SCUOLA PARITARIA,SCUOLA EBRAICA DI TORINO,E. ARTOM",
	"PRIMARIA,SCUOLA PARITARIA,Santo NATALE",
	"SECONDARIA I GRADO,SCUOLA PARITARIA,Santo NATALE",
	"INFANZIA,SCUOLA PARITARIA,Santo NATALE",
	"PRIMARIA,SCUOLA PARITARIA,SUORE FRANCESCANE ANGELINE",
	"SECONDARIA I GRADO,SCUOLA PARITARIA,SALESIANA VALSALICE",
	"SECONDARIA II GRADO,SCUOLA PARITARIA,SALESIANA VALSALICE",
	"SECONDARIA I GRADO,SCUOLA PARITARIA,MARIA CONSOLATRICE (ISMC)",
	"SCUOLA PRIMARIA,SCUOLA PARITARIA,ISTITUTO DEL BUON CONSIGLIO,ISTITUTO DEL BUON CONSIGLIO",
	"INFANZIA,SCUOLA PARITARIA,ISTITUTO DEL BUON CONSIGLIO,ISTITUTO DEL BUON CONSIGLIO",
	"INFANZIA,SCUOLA PARITARIA,SAN SECONDO",
	"INFANZIA,SCUOLA PRIVATA,AMBARABIMBI",
	"PRIMARIA,SCUOLA PRIVATA,AMBARABIMBI",
	"SECONDARIA II,SCUOLA PRIVATA,CENTRO STUDI RAFFAELLO",
	"SECONDARIA I GRADO,SCUOLA PRIVATA,SCUOLA VALDOCCO  DON BOSCO,DON BOSCO",
	"INFANZIA,SCUOLA PRIVATA,MADONNA DELLE ROSE",
	"INFANZIA,SCUOLA PRIVATA,MAMMA MARGHERITA",
	"INFANZIA,SCUOLA PRIVATA,SAN MASSIMO BILINGUE",
	"INFANZIA,SCUOLA PRIVATA,BUDDIES ELEMENTARY",
	"INFANZIA,SCUOLA PRIVATA,CONIUGI VERNA CAMPIDOGLIO MARTINETTO",
	"INFANZIA,SCUOLA PRIVATA,FRANCESCA DURIO",
	"INFANZIA,SCUOLA PRIVATA,ME LA RIDO",
	"INFANZIA,SCUOLA PRIVATA,PROJECT CUCCIOLO",
	"INFANZIA,SCUOLA PRIVATA,SUOR TARCISIA PONCHIA",
	"INFANZIA,SCUOLA PRIVATA,JEAN GIONO LICEO FRANCESE INTERNAZIONALE",
	"PRIMARIA,SCUOLA PRIVATA,JEAN GIONO LICEO FRANCESE INTERNAZIONALE",
	"SECONDARIA I GRADO,SCUOLA PRIVATA,JEAN GIONO LICEO FRANCESE INTERNAZIONALE",
	"SECONDARIA II,SCUOLA PRIVATA,JEAN GIONO LICEO FRANCESE INTERNAZIONALE,LICEO",
	"SECONDARIA II,SCUOLA PRIVATA,SALESIANI DON BOSCO,MICHELE RUA",
	"SECONDARIA I GRADO,SCUOLA PRIVATA,SALESIANI DON BOSCO,MICHELE RUA",
	"NIDO DI INFANZIA,SCUOLA PRIVATA,AMICI DI PIMPA",
	"NIDO DI INFANZIA,SCUOLA PRIVATA,PAN DI ZENZERO",
	"INFANZIA,SCUOLA PRIVATA,PAN DI ZENZERO",
	"NIDO IN FAMIGLIA,SCUOLA PRIVATA,NIDO IN FAMIGLIA DA VICHI",
	"INFANZIA,SCUOLA PRIVATA,SAINT DENIS SCHOOL,INFANZIA E PRIMAVERA",
	"PRIMARIA,SCUOLA PRIVATA,SAINT DENIS SCHOOL",
	"INFANZIA,SCUOLA PRIVATA,WORLD INTERNATIONAL SCHOOL",
	"PRIMARIA,SCUOLA PRIVATA,WORLD INTERNATIONAL SCHOOL",
	"SECONDARIA I GRADO,SCUOLA PRIVATA,WORLD INTERNATIONAL SCHOOL",
	"SECONDARIA II,SCUOLA PRIVATA,WORLD INTERNATIONAL SCHOOL",
	"SCUOLA  DI FORMAZIONE PROFESSIONALE,SCUOLA PRIVATA,Forte Chance Piemonte,Forte Chance Piemonte",
	"INFANZIA,SCUOLA PRIVATA,LA FARFALLA A POIS,LA FARFALLA A POIS",
	"SCUOLA  DI FORMAZIONE PROFESSIONALE,SCUOLA PRIVATA,GALILEO GALILEI,Istituto Galileo Galilei",
	"NIDO,SCUOLA PRIVATA,ASILO NIDO MINIDOU,ASILO NIDO MINIDOU",
	"INFANZIA,SCUOLA PRIVATA,Scuola Materna Nostra Signora Del Sacro Cuore di gesu,Scuola Materna Nostra Signora Del Sacro Cuore di gesu",
	"INFANZIA,SCUOLA PRIVATA,Parr. S. Teresa di Ges bambino",
	"INFANZIA,SCUOLA PRIVATA,SCUOLA MONTESSORI,MATERNA",
	"PRIMARIA,SCUOLA PRIVATA,SCUOLA MONTESSORI,PRIMARIA",
	"PRIMARIA,SCUOLA PRIVATA GRUPPO POPPY,BEST BILINGUAL EUROEPAN SCHOOL OF TURIN",
	"SECONDARIA I GRADO,SCUOLA PRIVATA GRUPPO POPPY,BEST Middle School",
	"AGENZIA FORMAZIONE PROFESSIONALE,SCUOLA PROFESSIONALE,ENAIP-CSF TORINO",
	"AGENZIA FORMAZIONE PROFESSIONALE,SCUOLA PROFESSIONALE,ENGIM,ARTIGIANELLI",
	"AGENZIA FORMAZIONE PROFESSIONALE,SCUOLA PROFESSIONALE,ENGIM,SAN LUCA",
	"INFANZIA,INFANZIA,ALDA MERINI",
	"INFANZIA,INFANZIA,Duchessa Elena D'Aosta,Duchessa Elena D'Aosta",
	"NIDO,NIDO,ASILO NIDO GIOTTO",
]

/*



 */
